import React, { DragEvent } from 'react'

import RPath from 'ramda/src/path'
import { Block, Change } from 'slate'
import { getEventRange } from 'slate-react'

import MomentPreviewCard from '~/components/MomentPreviewCard'

import { Next, OnDropProps, RenderNodeProps, SerializeProps } from '../types'

export default {
  onDrop: (e: DragEvent, { editor }: OnDropProps, next: Next) => {
    const droppedData = e.dataTransfer.getData('data')

    if (!droppedData || JSON.parse(droppedData).type !== 'moment') {
      return next()
    }

    const range = getEventRange(e, editor)
    if (!range) return next()

    return editor.change((change: Change) =>
      change.insertBlockAtRange(
        range,
        Block.create({
          type: 'moment',
          data: JSON.parse(droppedData),
        })
      )
    )
  },

  renderNode: ({ node }: RenderNodeProps, next: Next) => {
    if (node.type !== 'moment') return next()

    const data = node.data.toJS()

    const typeId = RPath<number>(['data', 'typeId'], data)
    if (!typeId) return next()

    return <MomentPreviewCard id={typeId} />
  },

  serialize: (obj: SerializeProps) => {
    if (obj.object === 'block' && obj.type === 'moment') {
      return <p>Moment needs more finnese</p>
    }
  },
}
